import { Component, OnInit } from '@angular/core';
import { ServiceService } from '../service.service';

@Component({
  selector: 'app-machine',
  templateUrl: './machine.component.html',
  styleUrls: ['./machine.component.css']
})
export class MachineComponent implements OnInit {

  constructor(private machineService:ServiceService) { }
  CreateMachineShown=false;
  M_Name="*";
  output:any=[];
  next_output:any=[];
  prv_output:any=[];
  deleteMachineName="";
  deleteMachineId="";
  msg1=""
  loaderShown=true;
  cardShown=false;
 
  count=0;
  New_count=0
  data={
    machine_name:""
  }
 
  AddMachineCard(){
    this.data.machine_name="";
  this.CreateMachineShown=!this.CreateMachineShown
  }
  AddMachine(){
    if(this.data.machine_name==""){
      this.M_Name="Enter a machine name";
      return;
    }
    else{
      
      this.machineService.AddMachine(this.data).subscribe((res)=>{
        console.log(res)
        
       if(res.sucess=='false'){
        this.M_Name=res.message;
       }
       else{
        this.CreateMachineShown=!this.CreateMachineShown;
        this.ngOnInit();
       }
      })
    
    }

  }
  SetMachineId(Id:any,Name:any){
    this.deleteMachineId=Id;
    this.deleteMachineName=Name;
  }
//------function for delete selected folder----------
DeleteMachine(){
  this.machineService.DeleteMachine(this.deleteMachineId).subscribe((res)=>{
   this.ngOnInit();
  })

}
//---------check value changes in the text box----
valuechange1(newValue1: any) {
  this.data.machine_name=newValue1
  this.M_Name="*"
}

//---function for click previous----------
clicks_previous(){
  if(this.New_count==0){
    return;
  }
  else{
    this.New_count=this.New_count-1;
    this.count=this.New_count; 
  }
  this.machineService.GetMachine(this.count).subscribe((res)=>{
    this.output=res.data
  })

}
//-------function for click next-------
clicks_next(){
  this.count=this.count+1
  this.machineService.GetMachine(this.count).subscribe((res)=>{
    this.next_output=res.data
    if(this.next_output.length!=0){
      this.output=this.next_output;
      this.New_count=this.count;
    }
  })


}
  ngOnInit(): void {

    this.loaderShown=true;
    this.cardShown=false;
    /*
    this.count=0;
    this.New_count=0;
*/
    this.machineService.GetMachine(this.count).subscribe((res)=>{
      this.output=res.data

      this.loaderShown=false;
      this.cardShown=true;

     console.log("On init",res)
    })
  }

}




